import Features from '../components/Features';

function Index() {
  return <Features />;
}

export default Index;
